// extracted by mini-css-extract-plugin
module.exports = {"header":"Rental_header__ozmiP"};